import { AxiomReportType } from '@/enums/axiom-report.enum'
import { IReturnVarianceReportDailyAttribution } from '@/interfaces/rvReport.interface'
import { defaultColDefs } from '@/utils/grid-utils/colDefs'
import { getUpdatedColumnsWithTooltip } from '@/utils/tableGridUtils'
import {
  GridReadyEvent,
  ModuleRegistry,
  RowClassParams,
} from '@ag-grid-community/core'
import { CsvExportModule } from '@ag-grid-community/csv-export'
import { AgGridReact } from '@ag-grid-community/react'
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export'
import { RVSummaryTableColumns } from '@components/ReturnVariance/ColumnDefs/RVSummaryTableColumns'
import { sideBarDefaultConfig } from '@utils/grid-utils/ag-grid-config'
import React, { useRef } from 'react'
export type IRVSummary = {
  rowData: IReturnVarianceReportDailyAttribution[]
  setGridReference: Function
}

ModuleRegistry.registerModules([CsvExportModule, ExcelExportModule])
export const RVSummaryTable: React.FC<IRVSummary> = ({
  rowData,
  setGridReference,
}) => {
  const themeClassName = 'ag-theme-quartz'
  const gridRef = useRef<AgGridReact>(null)

  const onGridReady = (params: GridReadyEvent) => {
    if (document.body.clientWidth > 1400) {
      params.api.sizeColumnsToFit()
    } else {
      params.api.autoSizeAllColumns()
    }
    setGridReference(gridRef)
  }

  const getRowClass = (params: RowClassParams) => {
    if (params.node.level === -1) {
      return 'grand-total-row'
    }
    return ''
  }

  return (
    <div
      className={`${themeClassName}`}
      style={{ paddingBottom: '2rem', height: '100%' }}
    >
      <AgGridReact
        ref={gridRef}
        onGridReady={onGridReady}
        defaultColDef={defaultColDefs}
        suppressAggFuncInHeader={true}
        columnDefs={getUpdatedColumnsWithTooltip(
          RVSummaryTableColumns,
          AxiomReportType.RV,
        )}
        rowData={rowData}
        sideBar={sideBarDefaultConfig}
        grandTotalRow={'bottom'}
        getRowClass={getRowClass}
        data-cy='ag-grid'
      ></AgGridReact>
    </div>
  )
}
